import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import moment from 'moment';

import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Box,
    Button,
    TextField,
    Grid,
    Avatar,
    Typography,
    CardActions,
    colors
} from '@material-ui/core';


const useStyles = makeStyles(() => ({
    root: {
    },
    avatar: {
        height: 152,
        width: 152,
        backgroundColor: colors.grey[400]
    }
}));

const CompanyProfile = ({ item, updateValues }) => {

    const classes = useStyles();

    return (

        <Grid container
            spacing={2}
        >

            <Grid
                item
                md={4}
                xs={12}>
                <Card >
                    <CardContent>
                        <Box
                            alignItems="center"
                            display="flex"
                            flexDirection="column"
                        >
                            <Avatar className={classes.avatar}>

                                {(item.logo.width > 1) ? (
                                    <img
                                        alt="Logo"
                                        src={"/static/" + item.logo.image}
                                        width={item.logo.width}
                                        height={item.logo.height}
                                    />
                                ) : (
                                    <img
                                        alt="Logo"
                                        src={"/static/" + item.logo.image}
                                    />
                                )}


                            </Avatar>
                            <Typography align="center"
                                color="textSecondary"
                                gutterBottom
                                variant="h4"
                            >
                                {item.name}
                            </Typography>

                            <Typography align="center" gutterBottom color="secondary" variant="h5">
                                {item.detail}
                            </Typography>

                            <Typography align="center" gutterBottom color="secondary" variant="body2">
                                Criada em : {moment(item.createdAt).format('DD/MM/YYYY')}
                            </Typography>

                        </Box>
                    </CardContent>
                    <Divider />
                    <CardActions>
                        <Button
                            color="secondary"
                            fullWidth
                            variant="text"
                            disabled={true}
                        >
                            Alterar Imagem
                        </Button>
                    </CardActions>
                </Card>

            </Grid>

            <Grid
                item
                md={8}
                xs={12}>

                <Card>
                    <CardHeader
                        subheader="As informações de indentificação da operação poderão ser editadas aqui"
                        title="Operação"
                    />
                    <Divider />
                    <CardContent>

                        <Box
                            display="flex"
                            flexDirection="column"
                            height="100%"
                            justifyContent="center"
                        >

                            <Formik
                                initialValues={item}
                                validationSchema={
                                    Yup.object().shape({
                                        name: Yup.string().max(50).required('Cliente é obrigatório'),
                                        detail: Yup.string().max(50).required('Nome é o obrigatório'),
                                        description: Yup.string().max(255).required('Descrição é obrigatória')
                                    })
                                }
                                onSubmit={(values, formik) => {
                                    updateValues(values);
                                    formik.setSubmitting(false);
                                }}
                            >
                                {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    touched,
                                    values
                                }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                                md={6}
                                                xs={12}
                                            >

                                                <TextField
                                                    error={Boolean(touched.name && errors.name)}
                                                    fullWidth
                                                    required
                                                    label="Cliente"
                                                    margin="nome"
                                                    name="name"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                md={6}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.detail && errors.detail)}
                                                    fullWidth
                                                    label="Nome"
                                                    margin="nome"
                                                    name="detail"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.detail}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>
                                            <Grid
                                                item
                                                md={12}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.description && errors.description)}
                                                    fullWidth
                                                    label="Descrição"
                                                    rows={2}
                                                    multiline
                                                    margin="nome"
                                                    name="description"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.description}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                        </Grid>

                                        <Box my={1}></Box>
                                        <Divider />

                                        <Box my={1}>
                                            <Grid container
                                                direction="row"
                                                justify="flex-end"
                                                alignItems="baseline"
                                                spacing={1}  >
                                                <Grid item >
                                                    <Button
                                                        color="secondary"
                                                        disabled={isSubmitting}
                                                        size="small"
                                                        type="submit"
                                                        variant="contained">
                                                        Salvar
                                                    </Button>
                                                </Grid>

                                            </Grid>
                                        </Box>

                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </CardContent>
                </Card>

            </Grid>

        </Grid>
    );
};

export default CompanyProfile;
